<template>
  <section class="stimulate">
    <div class="center">
      <h3>员工激励的价值</h3>
      <p>企业文化宣导、提高员工工作积极性、提供全方位评估依据</p>
      <div class="content">
        <img class="lf" src="@/assets/image/stimulate.png"/>
        <ul class="lf">
          <li>
            <h5>企业内部激励</h5>
            <p>激活员工工作热情，给予员工不同的积分奖励以及精神激励，充分调动起工作积极性。 </p>
          </li>
          <li>
            <h5>阶梯式奖励</h5>
            <p>当员工完成某一目标时，可随时以积分奖励的形式发放到员工账户内，员工可在企业专属积分商城进行兑换消费，
              建立企业与员工间的管理，提升员工工作动力及全面评价员工价值。 </p>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'Stimulate',
  props: {
  }
}
</script>
<style scoped lang="less">
.stimulate {
  height: 555px;
  width: 100%;
  .center {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    color:@text-color;
    text-align: center;
    overflow: hidden;
    h3 {
      font-size:30px;
      font-family: @PingFangSC-Semibold;
      font-weight:600;
      line-height:42px;
      margin-top: 58px;
    }
    p {
      font-size:18px;
      font-family: @PingFangSC-Regular;
      font-weight:400;
      line-height:25px;
      margin-top: 10px;
    }
    .content {
      width: 1055px;
      margin: 36px auto 0px;
      overflow: hidden;
      img {
        width: 521px;
        height: 321px;
        margin-right: 93px;
      }
      ul {
        width: 441px;
        text-align: left;
        li {
          margin-top: 54px;
          h5 {
            font-size:22px;
            font-family: @PingFangSC-Semibold;
            font-weight:600;
            line-height:30px;
          }
          p {
            font-size:16px;
            font-family: @PingFangSC-Regular;
            font-weight:400;
            line-height:22px;
            margin-top: 10px;
          }
        }
        li:last-child {
          margin-top: 25px;
        }
      }
    }
  }
}
</style>
